// import Swiper from '/node_modules/swiper/swiper-bundle.js';
import Swiper from '../lib/swiper/swiper-bundle.js';

/***
 * Делает слайдеры по проекту
 * @type {{init: Window.k1Sliders.init, makeModalCardSlider: Window.k1Sliders.makeModalCardSlider, makeSliderCatalogRecommendation: Window.k1Sliders.makeSliderCatalogRecommendation, getCatalogRecommendation: (function(): (*|Element)), getCatalogViewed: (function(): (*|Element)), getDetailCardPictures: (function(): {main: (*|Element), thumbs: (*|Element)}), makeSliderGalleryDetailCard: Window.k1Sliders.makeSliderGalleryDetailCard, makeSliderCatalogViewed: Window.k1Sliders.makeSliderCatalogViewed}}
 */


window.dremVars.sliderHome = true;
window.dremVars.slider = null;

window.k1Sliders = {
	// swiper-container news-page__slider
	// swiper-button-prev news-page__prev news-page__arrow
	// swiper-pagination slider-dots  news-page__pagination

	getArticlesGoodsSliders: function () {
		return document.querySelectorAll(".swiper-container.news-page__slider");
	},

	makeArticlesGoodsSliders: function () {
		this.getArticlesGoodsSliders().forEach(slider => {
			new Swiper(slider, {
				direction: 'horizontal',
				loop: true,
				slidesPerView: 3,
				centeredSlides: false,
				slidesPerScroll: 1,
				slidesPerGroup: 1,
				// spaceBetween: 5,
				navigation: {
					nextEl: slider.closest(".news-page__goods").querySelector('.swiper-button-next.news-page__arrow'),
					prevEl: slider.closest(".news-page__goods").querySelector('.swiper-button-prev.news-page__arrow'),
				},
				pagination: {
					el: slider.closest(".news-page__goods").querySelector('.swiper-pagination.news-page__pagination'),
				},
				breakpoints: {
					320: {
						slidesPerView: 1,
					},
					992: {
						slidesPerView: 3,
						slidesPerScroll: 1,
						slidesPerGroup: 1,
					},
				}
			})
		})
	},

	getSliderHomePopular: function () {
		return document.querySelectorAll('.home-top-goods  .swiper-container');
	},

	makeSliderHomePopular: function () {
		var slidersHomePopular = this.getSliderHomePopular()

		slidersHomePopular.forEach(function(item, i, arr){
			window.dremVars.slider = new Swiper(slidersHomePopular[i], {
				spaceBetween: 20,
				// slidesPerView: 1,
				// slidesPerScroll: 1,
				// loop: false,
				// a11y: {
				// 	enabled: false
				// },
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				breakpoints: {
					320: {
						slidesPerView: 1,
						slidesPerScroll: 1,
						slidesPerGroup: 1,

					},
					560: {
						slidesPerView: 1,
						slidesPerScroll: 1,
						slidesPerGroup: 1,
					},
					768: {
						slidesPerView: 3,
						slidesPerScroll: 3,
						slidesPerGroup: 3,

					}
				}
			});
		});
	},

	removeSlider: function () {
		if (window.dremVars.slider != null) {
			window.dremVars.slider.destroy(true, true);
			window.dremVars.slider = null;
		}
	},

	destroySlider: function (slider) {
		slider.destroy(true, false)
	},

	getDetailCardPictures: function () {

		return {
			thumbs: document.querySelector('.good-element__slider-navigate-container'),
			main: document.querySelector('.good-element__slider-big-container '),
			center: document.querySelector('.good-element__slider-navigate.k1-centered'),
		}
	},

	makeSliderGalleryDetailCard: function (main, nav, center = false) {

		let galleryThumbs = new Swiper(nav, {
			spaceBetween: 10,
			slidesPerView: 4,
			loop: false,
			centeredSlides: center,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
		});

		let galleryTop = new Swiper(main, {
			spaceBetween: 10,
			slidesPerView: 1,
			loop: false,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			thumbs: {
				swiper: galleryThumbs
			},

		});

	},

	getCatalogRecommendation: function () {
		return document.querySelector('.catalog-recommend__slider.swiper-container');
	},

	makeSliderCatalogRecommendation: function (slider) {
		if( !slider.classList.contains('swiper-container-initialized') ) {
			let recommendSlider = new Swiper(slider, {
				// slidesPerView: 4,
				// slidesPerScroll: 4,
				// slidesPerGroup: 4,
				// loop: false,
				navigation: {
					nextEl: '.swiper-button-next.catalog-recommend__next',
					prevEl: '.swiper-button-prev.catalog-recommend__prev',
				},
				pagination: {
					el: '.swiper-pagination.catalog-recommend__pagination',
					clickable: true
				},

				breakpoints: {
					100: {
						slidesPerView: 1,
						slidesPerScroll: 1,
						slidesPerGroup: 1,
					},
					400: {
						slidesPerView: 2,
						slidesPerScroll: 2,
						slidesPerGroup: 2,
					},
					768: {
						slidesPerView: 3,
						slidesPerScroll: 3,
						slidesPerGroup: 3,

					},
					1199: {
						slidesPerView: 4,
						slidesPerScroll: 4,
						slidesPerGroup: 4,
					}
				},
			});
		}
	},

	getCatalogViewed: function () {
		return document.querySelector('.catalog-viewed__slider.swiper-container');
	},

	makeSliderCatalogViewed: function (slider) {
		if( !slider.classList.contains('swiper-container-initialized') ) {
			let recommendSlider = new Swiper(slider, {
				slidesPerView: 4,
				slidesPerScroll: 4,
				slidesPerGroup: 4,
				loop: false,
				navigation: {
					nextEl: '.swiper-button-next.catalog-viewed__next',
					prevEl: '.swiper-button-prev.catalog-viewed__prev',
				},
				pagination: {
					el: '.swiper-pagination.catalog-viewed__pagination',
					clickable: true
				},
				breakpoints: {
					100: {
						slidesPerView: 1,
						slidesPerScroll: 1,
						slidesPerGroup: 1,
						// pagination: {
						// 	el: '.swiper-pagination.catalog-viewed__pagination',
						// 	clickable: true
						// },

					},
					400: {
						slidesPerView: 2,
						slidesPerScroll: 2,
						slidesPerGroup: 2,

						// pagination: {
						// 	el: '.swiper-pagination.catalog-viewed__pagination',
						// 	clickable: true
						// },

					},
					768: {
						slidesPerView: 3,
						slidesPerScroll: 3,
						slidesPerGroup: 3,

					},
					1199: {
						slidesPerView: 4,
						slidesPerScroll: 4,
						slidesPerGroup: 4,
					}
				},
				// pagination: {
				// 	el: '.swiper-pagination.catalog-viewed__pagination',
				// 	clickable: true
				// },
			});
		}
	},

	makeModalCardSlider: function () {
		const swiperCard = new Swiper('.swiper-container.good-item-picture__slider-container', {

			// Optional parameters
			direction: 'horizontal',
			loop: true,
			slidesPerView: 1,
			speed: 700,

			// If we need pagination
			pagination: {
				el: '.swiper-pagination.good-item-picture__pagination',
				clickable: true
			},

			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next.good-item-picture__next',
				prevEl: '.swiper-button-prev.good-item-picture__prev',
			},
		});
	},

	makeSlierComparePage: function (checkContainer, swiperContainer) {
		if (!checkContainer) return false;
		new Swiper(swiperContainer, {
			slidesPerView: 3,
			slidesPerScroll: 1,
			loop: false,
			navigation: {
				nextEl: '.swiper-button-next.compare__next',
				prevEl: '.swiper-button-prev.compare__prev',
			},
			scrollbar: {
				el: '.swiper-scrollbar',
				hide: false,
				draggable: true
			},
		});
	},

	getBrandsContainer: function (name) {
		// return document.querySelector(".swiper-container.brands__slider")
		return document.querySelector(name)
	},

	makeBrandsSlider: function (swiperContainer, inHeader = false, pagination) {
		let slider;


		if (swiperContainer.classList.contains("brands__slider-small")) {
			slider = new Swiper(swiperContainer, {
				direction: 'horizontal',
				loop: true,
				slidesPerView: 3,
				centeredSlides: false,
				slidesPerGroup: 3,
				mousewheel: true,
				navigation: {
					nextEl: '.swiper-button-next.brands__arrow',
					prevEl: '.swiper-button-prev.brands__arrow',
				},
				pagination: {
					el: pagination,
					clickable: true
				},

				breakpoints: {
					320: {
						slidesPerView: 1.4,
						centeredSlides: false,
					},
					430: {
						slidesPerView: 3,
						slidesPerScroll: 3,
						centeredSlides: false,

					},
					768: {
						slidesPerView: 3,
						slidesPerScroll: 3,
						centeredSlides: false,

					},
					991: {
						slidesPerView: 3,
					},
					1199: {
						slidesPerView: 3,
					}
				},

			});
		} else {
			if (inHeader) {
				slider = new Swiper(swiperContainer, {
					direction: 'horizontal',
					loop: true,
					slidesPerView: 6,
					centeredSlides: false,
					slidesPerGroup: 3,
					mousewheel: true,
					navigation: {
						nextEl: '.swiper-button-next.brands__arrow',
						prevEl: '.swiper-button-prev.brands__arrow',
					},
					pagination: {
						el: pagination,
						clickable: true
					},

					breakpoints: {
						320: {
							slidesPerView: 1.4,
							centeredSlides: false,
						},
						430: {
							slidesPerView: 3,
							slidesPerScroll: 3,
							centeredSlides: false,

						},
						768: {
							slidesPerView: 3,
							slidesPerScroll: 3,
							centeredSlides: false,

						},
						991: {
							slidesPerView: 5,
						},
						1199: {
							slidesPerView: 6,
						}
					},

				});
			} else {
				slider = new Swiper(swiperContainer, {
					direction: 'horizontal',
					loop: true,
					slidesPerView: 7,
					centeredSlides: true,
					mousewheel: true,
					navigation: {
						nextEl: '.swiper-button-next.brands__arrow',
						prevEl: '.swiper-button-prev.brands__arrow',
					},
					pagination: {
						el: '.swiper-pagination.brands__pagination',
						clickable: true

					},

					breakpoints: {
						320: {
							slidesPerView: 2.4,
							centeredSlides: false,
						},
						430: {
							slidesPerView: 3,
							centeredSlides: false,

						},
						768: {
							slidesPerView: 3,
							centeredSlides: false,

						},
						991: {
							slidesPerView: 5,
						},
						1199: {
							slidesPerView: 7,
						}
					},

				});
			}
		}

		return slider;

	},


	makeBrandsSliderInHeader: function () {

	},

	init: function () {
		if (this.getDetailCardPictures()) {
			this.makeSliderGalleryDetailCard(this.getDetailCardPictures().main, this.getDetailCardPictures().thumbs, this.getDetailCardPictures().center)
		}
		if (this.getCatalogRecommendation()) {
			this.makeSliderCatalogRecommendation(this.getCatalogRecommendation())
		}
		if (this.getCatalogViewed()) {
			this.makeSliderCatalogViewed(this.getCatalogViewed())
		}
		if (this.getSliderHomePopular()) {
			if (window.dremVars.sliderHome) {
				if (window.innerWidth <= 991) {
					if (window.dremVars.sliderHome) {
						this.makeSliderHomePopular();
						window.dremVars.sliderHome = false;
					}
				}
			}
		}
		// if (this.getArticlesGoodsSliders()) {
		// 	this.makeArticlesGoodsSliders();
		// }


		if (this.getBrandsContainer(".swiper-container.brands__slider")) this.makeBrandsSlider(this.getBrandsContainer(".swiper-container.brands__slider"));

		this.makeSlierComparePage(document.querySelector('.compare__slider-container'), document.querySelector('.compare__slider.swiper-container'));
	}

};

window.addEventListener('DOMContentLoaded', () => {
	window.k1Sliders.init();
});


window.addEventListener('resize', () => {

	if (window.innerWidth <= 991) {
		if (window.dremVars.sliderHome) {
			window.k1Sliders.makeSliderHomePopular();
			window.dremVars.sliderHome = false;
		}
	} else {
		// window.k1Sliders.removeSlider();
		window.dremVars.sliderHome = true;
	}


});